import { API_URL, customFetch } from '../..';
import { COOKIE_EVENT_ID, COOKIE_IDENTITY_ID, COOKIE_LOCATION_ID } from '../../../components/constants';
import { getCookie } from '../../../utils';
import { Menu } from './types';

/**
 * get available menu with products with the cookie information.
 * @yields data from https://portalsta.lacdev.cloud/api-details#api=commerce&operation=listActiveMenus
 */
export const getActiveMenus = async (): Promise<Menu[] | undefined> => {
    const url = `${API_URL?.replace('/v1', '/v2')}/product-management/active-menus`;

    const eventId = getCookie(COOKIE_EVENT_ID);
    const CustomerId = getCookie(COOKIE_IDENTITY_ID);
    const locationId = getCookie(COOKIE_LOCATION_ID);

    const requestData = {
        eventId,
        includeDescription: true,
        languageId: 'en-us',
        lookAhead: true,
        forceIncludeProductImages: false,
        menuPriceSearchArgs: {
            IncludeMenuItemPrices: true,
            CustomerId
        },
        locationId
    };

    const options: RequestInit = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestData)
    };

    try {
        const response = await customFetch(url, options);

        const data: Menu[] = await response;
        return data;
    } catch (error) {
        console.error('Failed to fetch menu:', error);
        return undefined;
    }
};
